import type { IconSvgObject } from './types';

const PointingRight02Icon: IconSvgObject = [
  ["path", { d: "M2 20H4L6.3108 20.9983C7.78747 21.7055 10.6774 22.6731 12.0382 21.3209C14.1833 19.1893 14.576 16.2081 14.5 14.4999L20.25 14.4999C21.2165 14.4999 22 13.7164 22 12.7499C22 11.7834 21.2165 10.9999 20.25 10.9999L14 10.9999M14 10.9999L10 11M14 10.9999C13.9889 10.9853 11.8269 8.12241 10.3914 7.62367C9.10843 7.17793 7.96635 8.03229 6.90858 8.67457C6.08953 9.1719 4 11 4 11H2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 4.5L19.5 2M22 4.5L19.5 7M22 4.5L16 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PointingRight02Icon;
